import React from 'react'
import styled from 'styled-components'
import Loader from '../../components/loaders/loader.component'
import PrivateMenu from './private-menu.component'
import PrivateFooter from '../../components/layout/private/private-footer.component'
import PrivateHeader from '../../components/layout/private/private-header/private-header.component'
import TripSearchBar from '../../components/trip-search-bar/trip-search-bar.component'
import { connect } from 'react-redux'
import { RoleConstants } from '../../constants'
import { bindActionCreators } from 'redux'
import StyledLayout from '../styled-layout.style'
import {
	ChangeAddressModal,
	NewAddressModal,
} from '../../components/form-components'
import { adminActions, clientActions, partnerActions } from '../../actions'
import { isMobile, setUserPermissions } from '../../helpers'

class PrivateLayoutComponent extends React.Component {
	constructor(props) {
		super(props)

		this.isUnmounted = false
		this.children = props.children
	}

	componentDidMount() {
		const { user, getAdminBalancePoints, getPartnerBalancePoints } =
			this.props
		this.isClient() && this.updatePoints()
		this.isAdmin() && getAdminBalancePoints()
		this.isPartner() && getPartnerBalancePoints()

		setUserPermissions(user)
	}

	isClient = () => this.props.role && this.props.role === RoleConstants.Client

	isAdmin = () => this.props.role && this.props.role === RoleConstants.Admin

	isPartner = () =>
		this.props.role && this.props.role === RoleConstants.Partner

	updatePoints = () => {
		const { getPointsInformation } = this.props
		getPointsInformation()
	}

	render() {
		const {
			loading,
			noPadding,
			role,
			isOpenChangeModal,
			isOpenNewAddressModal,
		} = this.props

		return (
			<StyledLayout noPadding={noPadding}>
				<PrivateHeader transparent={false} role={role} />
				<TripSearchBar top={0} logged="true" />
				<StyledBody>
					<PrivateMenu role={role} />
					<StyledContent>{this.children}</StyledContent>
				</StyledBody>
				<Loader showLoader={loading} transparent />
				<ChangeAddressModal isOpen={isOpenChangeModal} />
				<NewAddressModal isOpen={isOpenNewAddressModal} />
				<PrivateFooter role={role} />
			</StyledLayout>
		)
	}
}

const StyledBody = styled.div`
	display: flex;
	margin-top: ${isMobile() ? '' : '157px'};
`

const StyledContent = styled.div`
	flex: 1;
	overflow: hidden;
	padding-top: 2.4rem;
`

const mapStoreToProps = ({ site, user, addresses }) => {
	return {
		...site,
		user,
		isOpenNewAddressModal: addresses.isOpenNewAddressModal,
		isOpenChangeModal: addresses.isOpenChangeModal,
	}
}

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			...clientActions,
			getAdminBalancePoints: adminActions.getBalancePoints,
			getPartnerBalancePoints: partnerActions.getBalancePoints,
		},
		dispatch
	)

const connectedPrivateLayout = connect(
	mapStoreToProps,
	mapDispatchToProps
)(PrivateLayoutComponent)
export { connectedPrivateLayout as PrivateLayout }
